import React from 'react';
import { User } from 'lucide-react';
import { FieldDisplayProps } from '../../types';

export const PersonFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  onStartEditing,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (!isReadOnly) {
      onStartEditing();
    }
  };

  if (!value) {
    return (
      <div
        className="pill custom-field-pill editable empty-placeholder"
        onClick={handleClick}
      />
    );
  }

  // Parse person data from JSON if needed
  let personName = value;
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) {
      personName = parsed
        .map((p: { name?: string }) => p.name || '')
        .filter(Boolean)
        .join(', ');
    } else if (parsed.name) {
      personName = parsed.name;
    }
  } catch {
    // Plain string, use as-is
  }

  return (
    <div
      className="person-cell editable"
      onDoubleClick={handleClick}
      onClick={handleClick}
    >
      <User size={14} className="person-icon" />
      <span className="person-text">{personName}</span>
    </div>
  );
};

export default PersonFieldDisplay;
